import React from 'react'
import PropTypes from 'prop-types'
import gql from 'graphql-tag'
import { useQuery } from 'react-apollo'
import { IntlProvider } from 'react-intl'

const langQuery = gql`
  query i18nLang($langId: ID!) {
    lang(id: $langId) {
      id
      messages
    }
  }
`

const localeQuery = gql`
  query i18nLocale($localeId: ID!) {
    locale(id: $localeId) {
      id
      code
    }
  }
`
/**
 * Wrapper component around the IntlProvider that gets the locale code and the corresponding langId messages from graphql
 */
export default function I18n({ langId, localeId, onLocaleLoad, ...props }) {
  const { data: { lang: { messages } = {} } = {} } = useQuery(langQuery, { variables: { langId }, skip: !langId })
  const { data: { locale: { code } = {} } = {} } = useQuery(localeQuery, {
    variables: { localeId },
    skip: !localeId,
    onCompleted: () => onLocaleLoad && onLocaleLoad(code),
  })

  return code && messages ? <IntlProvider locale={code} messages={messages} {...props} /> : null
}

I18n.propTypes = {
  langId: PropTypes.string,
  localeId: PropTypes.string,
  onLocaleLoad: PropTypes.func,
}
